import React, { useState } from "react";
import style from "../styles/components/whatsappButton.module.scss";
import { X } from "lucide-react";
import Image from "next/image";
import whatsappIcon from "@/public/assets/whatsapp-icon-mkt.webp";

interface WhatsAppButtonProps {
  phoneNumber?: string;
  message?: string;
}

export default function WhatsAppButton({
  phoneNumber = "5511982312948",
  message = "Olá! Gostaria de saber mais informações.",
}: WhatsAppButtonProps) {
  const [showWhatsAppAlert, setShowWhatsAppAlert] = useState(false);

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
    setShowWhatsAppAlert(true);
  };

  const closeWhatsAppAlert = () => setShowWhatsAppAlert(false);

  return (
    <div className={style.whatsappButtonContainer}>
      <button
        className={style.whatsappButton}
        onClick={handleWhatsAppClick}
        aria-label="Contato via WhatsApp"
      >
        <Image
          src={whatsappIcon}
          alt="WhatsApp"
          width={50}
          height={50}
          loading="lazy"
        />
      </button>

      {showWhatsAppAlert && (
        <div className={style.whatsappAlert}>
          <button
            className={style.whatsappAlertClose}
            onClick={closeWhatsAppAlert}
            aria-label="Fechar alerta"
          >
            <X size={16} />
          </button>
          <p>Entre em contato conosco</p>
        </div>
      )}
    </div>
  );
}
